import { render, staticRenderFns } from "./ApprovalAuthorityEditor.vue?vue&type=template&id=758488c7&scoped=true&"
import script from "./ApprovalAuthorityEditor.vue?vue&type=script&lang=js&"
export * from "./ApprovalAuthorityEditor.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalAuthorityEditor.vue?vue&type=style&index=0&id=758488c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758488c7",
  null
  
)

export default component.exports